import { defineMessages } from './define'

/* The stock ledger, packs and standard yield, and stock alerts (lg.*). */

export default defineMessages({
  en: {
    'pr.print': 'Print',
    'pr.printSlip': 'Print ticket',
    'pr.printToken': 'Print token #{n}',
    'pr.sentRawbt': 'Sent to RawBT for printing.',
    'pr.failed': 'Could not print. Check the printer in App settings.',
    'pr.title': 'Ticket printer',
    'pr.note': 'Token slips for patients: the serial number, the doctor or test, and the time. Set up on this device.',
    'pr.method': 'Print with',
    'pr.system': 'Print dialog',
    'pr.rawbt': 'RawBT (Android)',
    'pr.systemHint': "This device's print dialog, sized to the roll. Choose the thermal printer there.",
    'pr.systemInAppHint': 'The Android app has no print dialog. Use RawBT to print from the app.',
    'pr.rawbtHint': 'Install RawBT from the Play Store and pair the Bluetooth or USB thermal printer in it once.',
    'pr.paper': 'Paper width',
    'pr.auto': 'Print the ticket after each booking',
    'pr.autoOn': 'On: the slip prints as soon as a booking is made.',
    'pr.autoOff': 'Off: tap Print ticket when the patient wants one.',
    'pr.test': 'Print a test slip',
    'lg.ledgerLink': 'Stock ledger',
    'lg.ledgerLinkSub': 'Purchases, tests per cartridge, cost per test, against last period',
    'lg.ledger': 'Ledger',
    'lg.thisMonth': 'This month',
    'lg.days90': '90 days',
    'lg.periodVs': '{from} – {to}, compared with {pfrom} – {pto}',
    'lg.purchases': 'Purchases',
    'lg.stockUsed': 'Stock used',
    'lg.patients': 'Patients',
    'lg.costPerTest': 'Cost per test',
    'lg.stockValueNow': 'Stock value',
    'lg.today': 'today',
    'lg.new': 'new',
    'lg.steady': 'About the same as before',
    'lg.tally': 'Tally',
    'lg.byItem': 'Item by item',
    'lg.bought': 'Bought',
    'lg.tests': 'Tests',
    'lg.perUnit': 'Tests/unit',
    'lg.showIdle': 'Show {n} idle',
    'lg.hideIdle': 'Hide idle',
    'lg.usedValue': 'used',
    'lg.opening': 'Opening',
    'lg.inTests': 'In tests',
    'lg.otherUse': 'Other use',
    'lg.countFix': 'Count fix',
    'lg.closing': 'Closing',
    'lg.packsN': '{n} × {pack}',
    'lg.testsPatients': '{tests} tests · {patients} patients',
    'lg.boughtFor': 'Bought for {amount}',
    'lg.costPerTestIs': '{amount} a test',
    'lg.yieldVsStd': '{n} tests per {unit} · standard {std} ({gap}%)',
    'lg.yieldOnly': '{n} tests per {unit}',
    'lg.vsBefore': 'Against the period before',
    'lg.note': 'Used = in tests + other use − what counts found extra. Tests per unit = tests done ÷ units used. A short count or spoilt units lower it.',
    'lg.pack': 'pack',
    'lg.packIs': '1 {pack} = {n} {unit}',
    'lg.standardIs': 'Standard: {n} tests / {unit}',
    'lg.packSize': 'Units in a pack ({unit})',
    'lg.packLabel': 'Pack name',
    'lg.packLabelPh': 'box, packet, kit',
    'lg.testsPerUnit': 'Tests per {unit} (standard)',
    'lg.testsPerUnitPh': 'e.g. 20 for a 20-test cartridge',
    'lg.testsPerUnitHint': 'Leave empty if it does not apply. A test then uses one share of it, and the ledger checks the real count against this.',
    'lg.testsWorth': '≈ {n} test(s) at {std} per {unit}',
    'lg.byPack': 'By {pack}',
    'lg.byUnit': 'By {unit}',
    'lg.packsCount': 'How many ({pack})',
    'lg.pricePerPack': 'Price per {pack}',
    'lg.packPreview': '= {n} {unit} at {each} each · {total} in all',
    'lg.alTitle': 'Stock alerts',
    'lg.alCountOut': '{n} out',
    'lg.alCountLow': '{n} low',
    'lg.alCountRunOut': '{n} running short',
    'lg.alCountYield': '{n} under standard',
    'lg.alItemsN': '{n} items',
    'lg.alOut': '{name} is out of stock.',
    'lg.alLow': '{name}: {n} {unit} left, alert at {level}.',
    'lg.alRunOut': '{name}: about {days} days left ({n} {unit}) at the recent rate.',
    'lg.alYield': '{name}: {n} tests per {unit} in 30 days, standard {std}.',
    'lg.alMore': 'And {n} more under Notifications.',
    'lg.alLater': 'Later',
    'lg.alOpen': 'Open stock',
    'lg.alPillSoon': 'Soon',
    'lg.alPillYield': 'Yield',
  },
  hi: {
    'pr.print': 'प्रिंट',
    'pr.printSlip': 'टिकट प्रिंट करें',
    'pr.printToken': 'टोकन #{n} प्रिंट करें',
    'pr.sentRawbt': 'प्रिंट के लिए RawBT को भेजा।',
    'pr.failed': 'प्रिंट नहीं हुआ। ऐप सेटिंग में प्रिंटर देखें।',
    'pr.title': 'टिकट प्रिंटर',
    'pr.note': 'मरीज़ों के लिए टोकन पर्ची: सीरियल नंबर, डॉक्टर या जाँच, और समय। इस डिवाइस पर सेट करें।',
    'pr.method': 'प्रिंट का तरीका',
    'pr.system': 'प्रिंट डायलॉग',
    'pr.rawbt': 'RawBT (Android)',
    'pr.systemHint': 'इस डिवाइस का प्रिंट डायलॉग, रोल के नाप का। वहाँ थर्मल प्रिंटर चुनें।',
    'pr.systemInAppHint': 'Android ऐप में प्रिंट डायलॉग नहीं है। ऐप से प्रिंट के लिए RawBT लें।',
    'pr.rawbtHint': 'Play Store से RawBT इंस्टॉल करें और उसमें ब्लूटूथ या USB थर्मल प्रिंटर एक बार जोड़ें।',
    'pr.paper': 'काग़ज़ की चौड़ाई',
    'pr.auto': 'हर बुकिंग के बाद टिकट प्रिंट करें',
    'pr.autoOn': 'चालू: बुकिंग होते ही पर्ची प्रिंट होती है।',
    'pr.autoOff': 'बंद: मरीज़ चाहे तो टिकट प्रिंट करें दबाएँ।',
    'pr.test': 'टेस्ट पर्ची प्रिंट करें',
    'lg.ledgerLink': 'स्टॉक खाता',
    'lg.ledgerLinkSub': 'ख़रीद, प्रति कार्ट्रिज जाँच, प्रति जाँच लागत, पिछली अवधि से तुलना',
    'lg.ledger': 'खाता',
    'lg.thisMonth': 'इस महीने',
    'lg.days90': '90 दिन',
    'lg.periodVs': '{from} – {to}, तुलना {pfrom} – {pto} से',
    'lg.purchases': 'ख़रीद',
    'lg.stockUsed': 'इस्तेमाल स्टॉक',
    'lg.patients': 'मरीज़',
    'lg.costPerTest': 'प्रति जाँच लागत',
    'lg.stockValueNow': 'स्टॉक मूल्य',
    'lg.today': 'आज',
    'lg.new': 'नया',
    'lg.steady': 'पहले जैसा ही',
    'lg.tally': 'मिलान',
    'lg.byItem': 'सामान अनुसार',
    'lg.bought': 'ख़रीदा',
    'lg.tests': 'जाँच',
    'lg.perUnit': 'जाँच/यूनिट',
    'lg.showIdle': '{n} बिना हलचल वाले दिखाएँ',
    'lg.hideIdle': 'बिना हलचल वाले छिपाएँ',
    'lg.usedValue': 'इस्तेमाल',
    'lg.opening': 'शुरुआती',
    'lg.inTests': 'जाँच में',
    'lg.otherUse': 'अन्य उपयोग',
    'lg.countFix': 'गिनती सुधार',
    'lg.closing': 'अंतिम',
    'lg.packsN': '{n} × {pack}',
    'lg.testsPatients': '{tests} जाँच · {patients} मरीज़',
    'lg.boughtFor': '{amount} में ख़रीदा',
    'lg.costPerTestIs': '{amount} प्रति जाँच',
    'lg.yieldVsStd': 'प्रति {unit} {n} जाँच · मानक {std} ({gap}%)',
    'lg.yieldOnly': 'प्रति {unit} {n} जाँच',
    'lg.vsBefore': 'पिछली अवधि से तुलना',
    'lg.note': 'इस्तेमाल = जाँच में + अन्य उपयोग − गिनती में मिला अतिरिक्त। प्रति यूनिट जाँच = जाँचें ÷ इस्तेमाल यूनिट। कम गिनती या ख़राब यूनिट इसे घटाते हैं।',
    'lg.pack': 'पैक',
    'lg.packIs': '1 {pack} = {n} {unit}',
    'lg.standardIs': 'मानक: प्रति {unit} {n} जाँच',
    'lg.packSize': 'एक पैक में यूनिट ({unit})',
    'lg.packLabel': 'पैक का नाम',
    'lg.packLabelPh': 'डिब्बा, पैकेट, किट',
    'lg.testsPerUnit': 'प्रति {unit} जाँच (मानक)',
    'lg.testsPerUnitPh': 'जैसे 20-जाँच कार्ट्रिज के लिए 20',
    'lg.testsPerUnitHint': 'लागू न हो तो खाली छोड़ें। तब हर जाँच इसका एक हिस्सा लेती है, और खाता असली गिनती को इससे मिलाता है।',
    'lg.testsWorth': '≈ {n} जाँच, प्रति {unit} {std}',
    'lg.byPack': '{pack} से',
    'lg.byUnit': '{unit} से',
    'lg.packsCount': 'कितने ({pack})',
    'lg.pricePerPack': 'प्रति {pack} दाम',
    'lg.packPreview': '= {n} {unit}, {each} प्रति · कुल {total}',
    'lg.alTitle': 'स्टॉक अलर्ट',
    'lg.alCountOut': '{n} ख़त्म',
    'lg.alCountLow': '{n} कम',
    'lg.alCountRunOut': '{n} जल्द ख़त्म',
    'lg.alCountYield': '{n} मानक से कम',
    'lg.alItemsN': '{n} सामान',
    'lg.alOut': '{name} स्टॉक में नहीं है।',
    'lg.alLow': '{name}: {n} {unit} बचा, अलर्ट {level} पर।',
    'lg.alRunOut': '{name}: मौजूदा दर से लगभग {days} दिन बचे ({n} {unit})।',
    'lg.alYield': '{name}: 30 दिन में प्रति {unit} {n} जाँच, मानक {std}।',
    'lg.alMore': 'और {n} सूचनाओं में।',
    'lg.alLater': 'बाद में',
    'lg.alOpen': 'स्टॉक खोलें',
    'lg.alPillSoon': 'जल्द',
    'lg.alPillYield': 'उपज',
  },
  mr: {
    'pr.print': 'प्रिंट',
    'pr.printSlip': 'तिकीट प्रिंट करा',
    'pr.printToken': 'टोकन #{n} प्रिंट करा',
    'pr.sentRawbt': 'प्रिंटसाठी RawBT ला पाठवले.',
    'pr.failed': 'प्रिंट झाले नाही. ॲप सेटिंगमध्ये प्रिंटर तपासा.',
    'pr.title': 'तिकीट प्रिंटर',
    'pr.note': 'रुग्णांसाठी टोकन चिठ्ठी: सिरीयल नंबर, डॉक्टर किंवा चाचणी, आणि वेळ. या डिव्हाइसवर सेट करा.',
    'pr.method': 'प्रिंटची पद्धत',
    'pr.system': 'प्रिंट डायलॉग',
    'pr.rawbt': 'RawBT (Android)',
    'pr.systemHint': 'या डिव्हाइसचा प्रिंट डायलॉग, रोलच्या मापाचा. तिथे थर्मल प्रिंटर निवडा.',
    'pr.systemInAppHint': 'Android ॲपमध्ये प्रिंट डायलॉग नाही. ॲपमधून प्रिंटसाठी RawBT वापरा.',
    'pr.rawbtHint': 'Play Store वरून RawBT इंस्टॉल करा आणि त्यात ब्लूटूथ किंवा USB थर्मल प्रिंटर एकदा जोडा.',
    'pr.paper': 'कागदाची रुंदी',
    'pr.auto': 'प्रत्येक बुकिंगनंतर तिकीट प्रिंट करा',
    'pr.autoOn': 'चालू: बुकिंग होताच चिठ्ठी प्रिंट होते.',
    'pr.autoOff': 'बंद: रुग्णाला हवे असल्यास तिकीट प्रिंट करा दाबा.',
    'pr.test': 'टेस्ट चिठ्ठी प्रिंट करा',
    'lg.ledgerLink': 'स्टॉक खातेवही',
    'lg.ledgerLinkSub': 'खरेदी, प्रति कार्ट्रिज चाचण्या, प्रति चाचणी खर्च, मागील कालावधीशी तुलना',
    'lg.ledger': 'खातेवही',
    'lg.thisMonth': 'या महिन्यात',
    'lg.days90': '90 दिवस',
    'lg.periodVs': '{from} – {to}, तुलना {pfrom} – {pto} शी',
    'lg.purchases': 'खरेदी',
    'lg.stockUsed': 'वापरलेला स्टॉक',
    'lg.patients': 'रुग्ण',
    'lg.costPerTest': 'प्रति चाचणी खर्च',
    'lg.stockValueNow': 'स्टॉक मूल्य',
    'lg.today': 'आज',
    'lg.new': 'नवीन',
    'lg.steady': 'आधीसारखेच',
    'lg.tally': 'ताळमेळ',
    'lg.byItem': 'वस्तूनिहाय',
    'lg.bought': 'खरेदी',
    'lg.tests': 'चाचण्या',
    'lg.perUnit': 'चाचणी/युनिट',
    'lg.showIdle': '{n} न हललेल्या दाखवा',
    'lg.hideIdle': 'न हललेल्या लपवा',
    'lg.usedValue': 'वापर',
    'lg.opening': 'सुरुवातीचा',
    'lg.inTests': 'चाचण्यांत',
    'lg.otherUse': 'इतर वापर',
    'lg.countFix': 'मोजणी दुरुस्ती',
    'lg.closing': 'अखेरचा',
    'lg.packsN': '{n} × {pack}',
    'lg.testsPatients': '{tests} चाचण्या · {patients} रुग्ण',
    'lg.boughtFor': '{amount} ला खरेदी',
    'lg.costPerTestIs': '{amount} प्रति चाचणी',
    'lg.yieldVsStd': 'प्रति {unit} {n} चाचण्या · मानक {std} ({gap}%)',
    'lg.yieldOnly': 'प्रति {unit} {n} चाचण्या',
    'lg.vsBefore': 'मागील कालावधीशी तुलना',
    'lg.note': 'वापर = चाचण्यांत + इतर वापर − मोजणीत जास्त आढळलेले. प्रति युनिट चाचण्या = चाचण्या ÷ वापरलेली युनिट. कमी मोजणी किंवा खराब युनिट हे कमी करतात.',
    'lg.pack': 'पॅक',
    'lg.packIs': '1 {pack} = {n} {unit}',
    'lg.standardIs': 'मानक: प्रति {unit} {n} चाचण्या',
    'lg.packSize': 'एका पॅकमधील युनिट ({unit})',
    'lg.packLabel': 'पॅकचे नाव',
    'lg.packLabelPh': 'खोका, पाकीट, किट',
    'lg.testsPerUnit': 'प्रति {unit} चाचण्या (मानक)',
    'lg.testsPerUnitPh': 'उदा. 20-चाचणी कार्ट्रिजसाठी 20',
    'lg.testsPerUnitHint': 'लागू नसल्यास रिकामे ठेवा. मग प्रत्येक चाचणी त्याचा एक भाग घेते, आणि खातेवही प्रत्यक्ष मोजणी याच्याशी जुळवते.',
    'lg.testsWorth': '≈ {n} चाचण्या, प्रति {unit} {std}',
    'lg.byPack': '{pack} नुसार',
    'lg.byUnit': '{unit} नुसार',
    'lg.packsCount': 'किती ({pack})',
    'lg.pricePerPack': 'प्रति {pack} किंमत',
    'lg.packPreview': '= {n} {unit}, प्रत्येकी {each} · एकूण {total}',
    'lg.alTitle': 'स्टॉक सूचना',
    'lg.alCountOut': '{n} संपले',
    'lg.alCountLow': '{n} कमी',
    'lg.alCountRunOut': '{n} लवकर संपणार',
    'lg.alCountYield': '{n} मानकापेक्षा कमी',
    'lg.alItemsN': '{n} वस्तू',
    'lg.alOut': '{name} स्टॉकमध्ये नाही.',
    'lg.alLow': '{name}: {n} {unit} शिल्लक, सूचना {level} वर.',
    'lg.alRunOut': '{name}: सध्याच्या दराने सुमारे {days} दिवस शिल्लक ({n} {unit}).',
    'lg.alYield': '{name}: 30 दिवसांत प्रति {unit} {n} चाचण्या, मानक {std}.',
    'lg.alMore': 'आणखी {n} सूचनांमध्ये.',
    'lg.alLater': 'नंतर',
    'lg.alOpen': 'स्टॉक उघडा',
    'lg.alPillSoon': 'लवकरच',
    'lg.alPillYield': 'उत्पादन',
  },
  or: {
    'pr.print': 'ପ୍ରିଣ୍ଟ',
    'pr.printSlip': 'ଟିକେଟ ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
    'pr.printToken': 'ଟୋକେନ #{n} ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
    'pr.sentRawbt': 'ପ୍ରିଣ୍ଟ ପାଇଁ RawBT କୁ ପଠାଗଲା।',
    'pr.failed': 'ପ୍ରିଣ୍ଟ ହେଲା ନାହିଁ। ଆପ ସେଟିଂରେ ପ୍ରିଣ୍ଟର ଦେଖନ୍ତୁ।',
    'pr.title': 'ଟିକେଟ ପ୍ରିଣ୍ଟର',
    'pr.note': 'ରୋଗୀଙ୍କ ପାଇଁ ଟୋକେନ ସ୍ଲିପ: ସିରିଆଲ ନମ୍ବର, ଡାକ୍ତର ବା ପରୀକ୍ଷା, ଏବଂ ସମୟ। ଏହି ଡିଭାଇସରେ ସେଟ କରନ୍ତୁ।',
    'pr.method': 'ପ୍ରିଣ୍ଟ ପଦ୍ଧତି',
    'pr.system': 'ପ୍ରିଣ୍ଟ ଡାୟଲଗ',
    'pr.rawbt': 'RawBT (Android)',
    'pr.systemHint': 'ଏହି ଡିଭାଇସର ପ୍ରିଣ୍ଟ ଡାୟଲଗ, ରୋଲ ମାପରେ। ସେଠାରେ ଥର୍ମାଲ ପ୍ରିଣ୍ଟର ବାଛନ୍ତୁ।',
    'pr.systemInAppHint': 'Android ଆପରେ ପ୍ରିଣ୍ଟ ଡାୟଲଗ ନାହିଁ। ଆପରୁ ପ୍ରିଣ୍ଟ ପାଇଁ RawBT ବ୍ୟବହାର କରନ୍ତୁ।',
    'pr.rawbtHint': 'Play Store ରୁ RawBT ଇନଷ୍ଟଲ କରନ୍ତୁ ଏବଂ ସେଥିରେ ବ୍ଲୁଟୁଥ ବା USB ଥର୍ମାଲ ପ୍ରିଣ୍ଟର ଥରେ ଯୋଡନ୍ତୁ।',
    'pr.paper': 'କାଗଜ ଓସାର',
    'pr.auto': 'ପ୍ରତି ବୁକିଂ ପରେ ଟିକେଟ ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
    'pr.autoOn': 'ଚାଲୁ: ବୁକିଂ ହେବା ମାତ୍ରେ ସ୍ଲିପ ପ୍ରିଣ୍ଟ ହୁଏ।',
    'pr.autoOff': 'ବନ୍ଦ: ରୋଗୀ ଚାହିଁଲେ ଟିକେଟ ପ୍ରିଣ୍ଟ ଦବାନ୍ତୁ।',
    'pr.test': 'ଟେଷ୍ଟ ସ୍ଲିପ ପ୍ରିଣ୍ଟ କରନ୍ତୁ',
    'lg.ledgerLink': 'ଷ୍ଟକ ଖାତା',
    'lg.ledgerLinkSub': 'କିଣା, କାର୍ଟ୍ରିଜ ପ୍ରତି ପରୀକ୍ଷା, ପରୀକ୍ଷା ପ୍ରତି ଖର୍ଚ୍ଚ, ପୂର୍ବ ଅବଧି ସହ ତୁଳନା',
    'lg.ledger': 'ଖାତା',
    'lg.thisMonth': 'ଏହି ମାସ',
    'lg.days90': '90 ଦିନ',
    'lg.periodVs': '{from} – {to}, {pfrom} – {pto} ସହ ତୁଳନା',
    'lg.purchases': 'କିଣା',
    'lg.stockUsed': 'ବ୍ୟବହୃତ ଷ୍ଟକ',
    'lg.patients': 'ରୋଗୀ',
    'lg.costPerTest': 'ପରୀକ୍ଷା ପ୍ରତି ଖର୍ଚ୍ଚ',
    'lg.stockValueNow': 'ଷ୍ଟକ ମୂଲ୍ୟ',
    'lg.today': 'ଆଜି',
    'lg.new': 'ନୂଆ',
    'lg.steady': 'ପୂର୍ବ ପରି',
    'lg.tally': 'ମିଳାଣ',
    'lg.byItem': 'ସାମଗ୍ରୀ ଅନୁସାରେ',
    'lg.bought': 'କିଣାଗଲା',
    'lg.tests': 'ପରୀକ୍ଷା',
    'lg.perUnit': 'ପରୀକ୍ଷା/ୟୁନିଟ',
    'lg.showIdle': '{n} ଅଚଳ ଦେଖାନ୍ତୁ',
    'lg.hideIdle': 'ଅଚଳ ଲୁଚାନ୍ତୁ',
    'lg.usedValue': 'ବ୍ୟବହୃତ',
    'lg.opening': 'ଆରମ୍ଭ',
    'lg.inTests': 'ପରୀକ୍ଷାରେ',
    'lg.otherUse': 'ଅନ୍ୟ ବ୍ୟବହାର',
    'lg.countFix': 'ଗଣନା ସଂଶୋଧନ',
    'lg.closing': 'ଶେଷ',
    'lg.packsN': '{n} × {pack}',
    'lg.testsPatients': '{tests} ପରୀକ୍ଷା · {patients} ରୋଗୀ',
    'lg.boughtFor': '{amount} ରେ କିଣାଗଲା',
    'lg.costPerTestIs': 'ପରୀକ୍ଷା ପ୍ରତି {amount}',
    'lg.yieldVsStd': '{unit} ପ୍ରତି {n} ପରୀକ୍ଷା · ମାନକ {std} ({gap}%)',
    'lg.yieldOnly': '{unit} ପ୍ରତି {n} ପରୀକ୍ଷା',
    'lg.vsBefore': 'ପୂର୍ବ ଅବଧି ସହ ତୁଳନା',
    'lg.note': 'ବ୍ୟବହୃତ = ପରୀକ୍ଷାରେ + ଅନ୍ୟ ବ୍ୟବହାର − ଗଣନାରେ ଅଧିକ ମିଳିଥିବା। ୟୁନିଟ ପ୍ରତି ପରୀକ୍ଷା = ପରୀକ୍ଷା ÷ ବ୍ୟବହୃତ ୟୁନିଟ। କମ ଗଣନା ବା ନଷ୍ଟ ୟୁନିଟ ଏହାକୁ କମାଏ।',
    'lg.pack': 'ପ୍ୟାକ',
    'lg.packIs': '1 {pack} = {n} {unit}',
    'lg.standardIs': 'ମାନକ: {unit} ପ୍ରତି {n} ପରୀକ୍ଷା',
    'lg.packSize': 'ଗୋଟିଏ ପ୍ୟାକରେ ୟୁନିଟ ({unit})',
    'lg.packLabel': 'ପ୍ୟାକର ନାମ',
    'lg.packLabelPh': 'ବାକ୍ସ, ପ୍ୟାକେଟ, କିଟ',
    'lg.testsPerUnit': '{unit} ପ୍ରତି ପରୀକ୍ଷା (ମାନକ)',
    'lg.testsPerUnitPh': 'ଯଥା 20-ପରୀକ୍ଷା କାର୍ଟ୍ରିଜ ପାଇଁ 20',
    'lg.testsPerUnitHint': 'ପ୍ରଯୁଜ୍ୟ ନହେଲେ ଖାଲି ରଖନ୍ତୁ। ତେବେ ପ୍ରତି ପରୀକ୍ଷା ଏହାର ଏକ ଅଂଶ ନିଏ, ଏବଂ ଖାତା ପ୍ରକୃତ ଗଣନାକୁ ଏହା ସହ ମିଳାଏ।',
    'lg.testsWorth': '≈ {n} ପରୀକ୍ଷା, {unit} ପ୍ରତି {std}',
    'lg.byPack': '{pack} ଅନୁସାରେ',
    'lg.byUnit': '{unit} ଅନୁସାରେ',
    'lg.packsCount': 'କେତେ ({pack})',
    'lg.pricePerPack': '{pack} ପ୍ରତି ଦାମ',
    'lg.packPreview': '= {n} {unit}, ପ୍ରତିଟି {each} · ମୋଟ {total}',
    'lg.alTitle': 'ଷ୍ଟକ ସତର୍କତା',
    'lg.alCountOut': '{n} ସରିଗଲା',
    'lg.alCountLow': '{n} କମ',
    'lg.alCountRunOut': '{n} ଶୀଘ୍ର ସରିବ',
    'lg.alCountYield': '{n} ମାନକରୁ କମ',
    'lg.alItemsN': '{n} ସାମଗ୍ରୀ',
    'lg.alOut': '{name} ଷ୍ଟକରେ ନାହିଁ।',
    'lg.alLow': '{name}: {n} {unit} ବାକି, ସତର୍କତା {level} ରେ।',
    'lg.alRunOut': '{name}: ବର୍ତ୍ତମାନ ହାରରେ ପ୍ରାୟ {days} ଦିନ ବାକି ({n} {unit})।',
    'lg.alYield': '{name}: 30 ଦିନରେ {unit} ପ୍ରତି {n} ପରୀକ୍ଷା, ମାନକ {std}।',
    'lg.alMore': 'ଆଉ {n} ବିଜ୍ଞପ୍ତିରେ।',
    'lg.alLater': 'ପରେ',
    'lg.alOpen': 'ଷ୍ଟକ ଖୋଲନ୍ତୁ',
    'lg.alPillSoon': 'ଶୀଘ୍ର',
    'lg.alPillYield': 'ଉତ୍ପାଦନ',
  },
})
